"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export function OAuthCallback() {
  const router = useRouter();

  useEffect(() => {
    // The backend has already issued the auth cookies on the redirect that
    // landed us here. Strip any leftover hash from prior versions of this
    // page, then continue into the app.
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }
    router.replace("/projects");
  }, [router]);

  return (
    <div className="flex h-svh items-center justify-center bg-surface-primary"></div>
  );
}
